import toastr from 'toastr';
import 'toastr/build/toastr.css';
import config from './index.config';
import routerConfig from './index.route';
import runBlock from './index.run';
import AuthInterceptorService from './AuthInterceptorService';
import MenuController from './MenuController';
import LoginController from './login/LoginController';
import HomeController from './HomeController';
import LagerController from './artikel/LagerController';
import ArtikelController from './artikel/ArtikelController';
import Iso14726Controller from './artikel/Iso14726Controller';
import RequestQuoteController from './artikel/requestQuoteController';
import AnfrageController from './anfragen/anfrageController';
import ShowErrors from './components/ShowErrors';
import VossIso from './components/VossIso';
import VossArtikelBild from './components/VossArtikelBild';
import KundenController from './kunden/KundenController';
import KundeController from './kunden/KundeController';
import KontaktController from './kontakt/KontaktController';
import RechnungenController from './rechnungen/RechnungenController';
import RechnungController from './rechnungen/RechnungController';
import RechnungNeuController from './rechnungen/RechnungNeuController';

import './natives.js';

const app = {
};

angular.module('vossWebApp', ['ngResource', 'ngRoute', 'ngSanitize', 'ui.bootstrap', 'LocalStorageModule', 'infinite-scroll', 'pascalprecht.translate'])
	.config(config)
	.config(routerConfig)
	.provider('AuthInterceptorService', AuthInterceptorService)
	.directive('showErrors', () => new ShowErrors())
	.directive('vossIso', () => new VossIso())
	.directive('vossArtikelBild', () => new VossArtikelBild())
	.controller('HomeController', HomeController)
	.controller('LoginController', LoginController)
	.controller('MenuController', MenuController)
	.controller('LagerController', LagerController)
	.controller('ArtikelController', ArtikelController)
	.controller('Iso14726Controller', Iso14726Controller)
	.controller('RequestQuoteController', RequestQuoteController)
	.controller('AnfrageController', AnfrageController)
	.controller('KundenController', KundenController)
	.controller('KundeController', KundeController)
	.controller('KontaktController', KontaktController)
	.controller('RechnungNeuController', RechnungNeuController)
	.controller('RechnungController', RechnungController)
	.controller('RechnungenController', RechnungenController)
	.run(runBlock);

window.getScopeByController = function (controller) {
	return angular.element('[ng-controller="' + controller + ' as vm"]').scope();
};

toastr.options.timeOut = 3000;
toastr.options.positionClass = 'toast-top-right';
toastr.options.preventDuplicates = true;
toastr.options.progressBar = true;

window.app = app;
window.toastr = toastr;

export default app;



/** WEBPACK FOOTER **
 ** ./public/app/index.js
 **/